module.exports = __webpack_public_path__ + "static/saasvisitor1-3a44cb919527feaea26ec7700d0dfeb2.png";